import { NO_STATE } from '../hooks/useExtendedState';

export const canFieldBeModified = (fieldName, modificationBlockers) => !modificationBlockers?.nonModifiableFields?.includes(fieldName);

export const resolveValue = (value, state) => {
    let result = null;
    if (typeof value === 'undefined') {
        if (state && state !== NO_STATE) {
            result = state.value;
        }
    } else {
        result = value;
    }
    return result;
};

export const resolveOnChange = (onChange, state) => {
    let result = null;
    if (typeof onChange === 'undefined') {
        if (state && state !== NO_STATE) {
            result = state.setValueIfNew;
        }
    } else {
        result = onChange;
    }
    return result;
};

export const resolveIsChanged = (isChanged, state) => {
    let result = false;
    if (typeof isChanged === 'undefined') {
        if (state && state !== NO_STATE) {
            result = state.isChanged;
        }
    } else {
        result = isChanged;
    }
    return result;
};

export const resolveOnReset = (onReset, state) => {
    let result = null;
    if (typeof onReset === 'undefined') {
        if (state && state !== NO_STATE) {
            result = state.reset;
        }
    } else {
        result = onReset;
    }
    return result;
};
